
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    defaultHeader,
  } from "@/utils/config"
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  import Dialog from '@/components/dialog.vue';
  import {
    memberPointmemberList,
    memberPointflowRecordList
  } from "@/api/agent_user"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private radioList = [
      {value:1,label:'积分管理'},
      {value:2,label:'积分明细'},
    ]
    private radioType = 1
    private keywords = ''
    private grade = null
    private gradelist = [
      {
        label: '全部',
        value: null
      }, {
        label: 'SVIC',
        value: 1
      }, {
        label: 'VIC',
        value: 2
      }, {
        label: 'VIP',
        value: 3
      }, 
      {
      	label: '客户',
      	value: 0
      }
    ]
    private phone = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1;
		private pageSize = 20;
		private total = 0;
    private defaultHeader = defaultHeader
    private rowmsg:any = {}
    private adjustShow = false
    private adjustMsg:any = {
      jftype:1,
      jfnum:'',
      jfremark:'',
    }
    private AllPoint = 0
    private keywords2 = ''
    private changeType = null
    private changeTypelist = [
      {value:null,label:'全部'},
      {value:1,label:'任务积分奖励'},
      {value:4,label:'后台增加积分'},
      {value:5,label:'后台扣减积分'},
    ]
    private filterTime = ''


    private mounted () {
      this.filterTime = [getSearchDate(1,false)[0],getSearchDate(2,false)[1]].join('/')
      this.gettablelist()
    }


    private async confirmAdjust(){
      if(this.adjustMsg.jfnum<1||this.adjustMsg.jfnum>99999999){
        this.$message.error('请输入1~99999999的整数')
        return
      }
      if(!this.adjustMsg.jfremark){
        this.$message.error('请输入原因')
        return
      }
      try{

      }finally{
        //
      }
    }
    private adjustPoint(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.adjustShow = true
    }
    private exportfile(){
      let url = location.origin
      if(this.radioType==1){
        url += '/pc/memberPoint/memberList'
        url += '?Keywords=' + encodeURIComponent(this.keywords)
        url += '&RoleGrade=' + (this.grade==null?'':this.grade)
      }else{
        url += '/pc/memberPoint/flowRecordList'
        url += '?Keywords=' + encodeURIComponent(this.keywords2)
        url += '&Type=' + (this.changeType==null?'':this.changeType)
        if(this.filterTime){
          let t = this.filterTime.split('/')
          url += '&StartTime=' + t[0]
          url += '&EndTime=' + nextDay(t[1],1)
        }
      }
      window.open(url)
    }
    private clearSearch(){
      if(this.radioType==1){
        this.keywords = ''
        this.grade = null
        this.phone = ''
      }else{
        this.keywords2 = ''
        this.changeType = null
        this.filterTime = [getSearchDate(1,false)[0],getSearchDate(2,false)[1]].join('/')
      }
      this.changePage(1)
    }
    private changePage(e){
      this.pageNo = e
      if(this.radioType==1){
        this.gettablelist()
      }else{
        this.gettablelist2()
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await memberPointmemberList({
          Keywords:this.keywords,
          RoleGrade:this.grade,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          this.AllPoint = res.Result.AllPoint
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist2(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords2,
          Type:this.changeType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res:any = await memberPointflowRecordList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
